import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { TermsOfUseAcceptanceDialog } from './'

export default observer(function Inner() {
  const testId = 'terms-of-use-acceptance-dialog'

  const { internal } = useFeatures((app) => ({
    internal: app.account.internal(),
  }))

  const vm = internal.termsOfUseAcceptanceVm

  return (
    <TermsOfUseAcceptanceDialog
      isOpen={vm.modal.showing}
      isLoading={vm.fetchLatestTerms.pending}
      termsMarkup={vm.terms.markup}
      agreed={vm.agreed}
      onAgreeChange={vm.setAgreed}
      onAccept={vm.accept}
      onDecline={vm.decline}
      isAcceptPending={vm.accept.pending}
      testId={testId}
      contentTestId={`${testId}-content`}
      agreeCheckboxTestId={`${testId}-agree-checkbox`}
      acceptButtonTestId={`${testId}-accept-button`}
      closeButtonTestId={`${testId}-close-button`}
    />
  )
})
